import React, { useEffect, useState, useCallback, useMemo, useRef } from 'react'
import { connect } from 'react-redux'
import Slider from 'react-slick'
import * as actions from '../../redux/actions'

import rp from 'request-promise-native'
import { uriV2 } from '../../services/defaultProps'
import { FiArrowLeft } from 'react-icons/fi'
import { useHistory, useParams } from 'react-router-dom'
import { getProductDescription, getProductTitle } from '../../services/ColoringProductsHelpers'
import { withWindowSizeListener } from 'react-window-size-listener'

import '../../styles/containers/ColoringProduct.css'
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa'
// import { fixLink } from '../../services/Helpers'
import useLanguage from '../../hooks/useLanguage'

const ColoringProductCarousel = props => {
  const sliderHeight = useMemo(() => props.windowSize.windowHeight - 75 - 16 - 50 - 15, [props.windowSize.windowHeight])
  const settings = useMemo(() => ({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerPadding: 0,
    useTransform: true,
    arrows: false,
    className: 'imagecarousel-slider',
    afterChange: page => {
      setPage(page)
      scrollToMiniature(page)
    }
  }), [])

  const [page, setPage] = useState(props.initialPhoto || 0)

  const miniaturesRef = useRef(null)

  const scrollToMiniature = index => {
    const left = index === 0 ? 0 : 24 + index * 60 + ((index - 1) * 12)

    miniaturesRef && miniaturesRef.current && miniaturesRef.current.scroll({
      left,
      behavior: 'smooth'
    })
  }

  let sliderRef

  useEffect(() => {
    const slider = document.getElementsByClassName('imagecarousel-slider')[0]
    if (sliderHeight > 0) {
      slider.style.height = `${sliderHeight}px`
      slider.style.width = '100%'
    }

    scrollToMiniature(props.initialPhoto)
  }, [props.windowSize.windowHeight])

  return (
    <div className='carousel-container'>
      <div className='imagecarousel-screen-carousel'>
        <div className='imagecarousel-slider-container'>
          <Slider
            ref={function (ref) {
              sliderRef = ref
            }} {...settings} initialSlide={props.initialPhoto || 0}>
            {props.products.map(product => {
              const productTitle = getProductTitle(product, props.language, { forceGetTitle: true })
              const productDescription = getProductDescription(product, props.language)

              return (
                <div key={product.id} className='carousel-child-element'>
                  <div style={{
                    height: sliderHeight,
                    backgroundColor: 'white',
                    display: 'flex',
                    flexDirection: 'column',
                    borderRadius: 12
                  }}>
                    <img src={product.url} alt={product.title_pt}
                      className='imagecarousel-image' />
                    {product.template_type === 'product' ? (
                      <div className='coloringproduct-description'>
                        <p className='coloringproduct-product-title'>
                          {productTitle}
                        </p>
                        {/* TODO: Foi comentado pois nao temos controle dos links disponiveis ou nao, dai por momento será somente vitrine, no futuro podemos voltar */}
                        {/* {!!product.link && (
                          <a href={fixLink(product.link)} target='_blank' rel='noopener' className='coloringproduct-product-buy'
                            onClick={() => product.unit_value && props.addProductToCart({name: productTitle,
                              unitValue: product.unit_value,
                              amount: 1,
                              externalLink: product.link,
                              image: product.url,
                              externalId: product.id.toString()})}>
                            Comprar
                          </a>
                        )} */}
                      </div>
                    ) : (product.template_type === 'imageAndText' && productDescription) ? (
                      <div className='coloringproduct-description'>
                        <p className='coloringproduct-product-description'>
                          {productDescription}
                        </p>
                      </div>
                    ) : false}
                  </div>
                </div>
              )
            })}
          </Slider>
          <button className='imagecarousel-prev' onClick={() => {
            const prevPage = page - 1 % props.products.length
            setPage(prevPage)
            scrollToMiniature(prevPage)
            sliderRef.slickPrev()
          }}>
            <FaChevronLeft color='var(--primary)' size={16} />
          </button>
          <button className='imagecarousel-next' onClick={() => {
            const nextPage = page + 1 % props.products.length
            setPage(nextPage)
            scrollToMiniature(nextPage)
            sliderRef.slickNext()
          }}>
            <FaChevronRight color='var(--primary)' size={16} />
          </button>
        </div>
      </div>
      <div className='imagecarousel-screen-miniatures' ref={miniaturesRef}>
        {props.products.map((product, index) => {
          return (
            <div key={product.id} onClick={() => {
              sliderRef.slickGoTo(index)
              setPage(index)
              scrollToMiniature(index)
            }} className={`imagecarousel-miniatures-item${page === index ? ' selected-miniature' : ''}`}>
              <img src={product.url} alt={product.url} />
            </div>
          )
        })}
      </div>
    </div>
  )
}

const Carousel = withWindowSizeListener(ColoringProductCarousel)

const ColoringProduct = props => {
  const history = useHistory()
  const language = useLanguage()
  const params = useParams()

  const subgroup = useMemo(() => {
    if (props.products.subgroupItems) {
      const selectedSubgroup = props.products.subgroupItems.find((subgroup) => {
        return subgroup.related_id.toString() === params.subgroup
      })
      return selectedSubgroup
    }
    return false
  }, [props.products.subgroupItems])

  const productsList = useMemo(() => subgroup ? subgroup.products : [], [subgroup])

  const isProductAlreadyInCart = useCallback((product) => {
    if (props.cart && props.cart.cartItems && props.cart.cartItems.length > 0) {
      return props.cart.cartItems.find(cartItem => (cartItem.externalId === product.externalId && !cartItem.isDeleted))
    }
    return false
  }, [props.cart])

  const addProductToCart = useCallback(async (product) => {
    const productAlreadyInCart = isProductAlreadyInCart(product)
    if (!productAlreadyInCart) {
      await rp({
        uri: `${uriV2}/shop/cart/item`,
        method: 'POST',
        headers: {
          Authorization: props.token
        },
        body: product,
        json: true
      }).then((response) => {
        props.setCart({ cart: response })
      })
    }
  }, [props.token])

  return (
    <div className='coloringproduct-screen-container'>
      <div className='coloringproduct-screen-title'>
        <FiArrowLeft onClick={() => history.goBack()}
          size={24} color='var(--primary)' className='coloringproduct-screen-goback' />
        <p>{getProductTitle(subgroup, language, { forceGetTitle: true })}</p>
      </div>
      <Carousel products={productsList} addProductToCart={addProductToCart} language={language} />
    </div>
  )
}

const mapStateToProps = state => {
  return {
    ...state.userReducer,
    products: state.productsReducer,
    cart: state.productsReducer.cart
  }
}

export default connect(
  mapStateToProps,
  actions
)(ColoringProduct)



// WEBPACK FOOTER //
// ./src/containers/Cromatica/ColoringProduct.js